// extracted by mini-css-extract-plugin
export default {"card":"VgqybWkyLDkGyxZni9Vc","title":"ihdotVBqaloDYwt87Asi","details":"GvlCZx1AO41wGxISUkdv"};